document.body.innerHTML = document.body.innerHTML.replace(
    /\b\d{3}[-.]?\d{3}[-.]?\d{4}\b/g,
    function(phoneNumber) {
        return '<a href="tel:' + phoneNumber + '">' + phoneNumber + '</a>';
    }
);